import { h, Host } from "@stencil/core";
import { ModalStatusEnum } from "./modal-status";
import { ModalMultiIndicator } from "./modal-multi-indicator";
import { getModalByName, getPriority } from "./modal-utils";
export class Modal {
    constructor() {
        this.name = "";
        this.priority = 5;
        this.closeButtonText = "";
        this.noCloseButton = false;
        this.closeOnEscKey = false;
        this.closeOnBackdropClick = false;
        this.reloadOnClose = false;
        this.stickyPosition = "center";
        this.opened = false;
        this.noGutterTop = false;
        this.status = ModalStatusEnum.CLOSED;
        this.multipleModals = null;
        this.multipleModalsCurrent = null;
    }
    domNode;
    /** Emitted when the modal is closed  */
    modalClosed;
    /** Emitted when the modal is opened  */
    modalOpened;
    /* eslint-disable */
    transitionTimeout = null;
    bodyScrollLock(isLocked) {
        if (isLocked) {
            document.body.classList.add("ux-body-scroll-lock");
        }
        else {
            document.body.classList.remove("ux-body-scroll-lock");
        }
    }
    /** Triggers modal closing */
    async triggerClose() {
        const evt = this.modalClosed.emit(this.name);
        if (!evt.defaultPrevented) {
            this.opened = false;
            if (this.reloadOnClose) {
                window.setTimeout(() => window.location.reload(), 250);
            }
        }
    }
    /** Triggers modal opening */
    async triggerOpen() {
        const evt = this.modalOpened.emit(this.name);
        if (!evt.defaultPrevented) {
            this.opened = true;
        }
    }
    onOtherClosedModal(e) {
        this.setMultipleModalsCurrent(this.getOpenMultipleModals(e.detail));
        if (this.multipleModalsCurrent === this.name && this.opened) {
            this.showModal();
        }
        this.bodyScrollLock(false);
    }
    onOtherOpenedModal(e) {
        const openedModalName = e.detail;
        const isAlreadyInCue = this.getOpenMultipleModals().includes(openedModalName);
        if (openedModalName === this.name || isAlreadyInCue) {
            return;
        }
        // @ts-expect-error Check for typing
        this.multipleModals.push(openedModalName);
        this.sortMultipleModals();
        this.setMultipleModalsCurrent(this.getOpenMultipleModals());
        this.bodyScrollLock(true);
    }
    /** Listen for opened state  */
    setModalStatus() {
        if (this.transitionTimeout !== null) {
            clearTimeout(this.transitionTimeout);
        }
        if (!this.opened) {
            if (this.status === ModalStatusEnum.CLOSED) {
                return;
            }
            this.status = ModalStatusEnum.CLOSING;
            this.transitionTimeout = setTimeout(() => {
                this.status = ModalStatusEnum.CLOSED;
            }, 350);
            return;
        }
        if (this.status === ModalStatusEnum.OPENED) {
            return;
        }
        this.initMultipleModals();
        // @ts-expect-error Check for typing
        if (this.multipleModals.length > 0 && !this.multipleModals.includes(this.name)) {
            // @ts-expect-error Check for typing
            this.multipleModals.push(this.name);
        }
        // @ts-expect-error Check for typing
        if (this.multipleModals.length < 2 || this.multipleModalsCurrent === this.name) {
            this.showModal();
        }
    }
    initMultipleModals() {
        if (this.multipleModals === null) {
            const initiallyOpenedModals = Array.from(document.querySelectorAll("ux-modal[opened]"));
            this.multipleModals = initiallyOpenedModals.map((modal) => modal.name);
        }
        this.sortMultipleModals();
        this.setMultipleModalsCurrent(this.getOpenMultipleModals());
    }
    setMultipleModalsCurrent(openedModals) {
        if (this.multipleModals === null) {
            return;
        }
        this.cleanupMultipleModals(openedModals);
        if (this.multipleModals.length > 0) {
            this.multipleModalsCurrent = openedModals[0];
        }
    }
    // @ts-expect-error Check for typing
    getOpenMultipleModals(exclude = null) {
        // @ts-expect-error Check for typing
        return this.multipleModals.filter((name) => {
            const modal = getModalByName(name);
            if (modal === null || name === exclude) {
                return false;
            }
            return modal.opened;
        });
    }
    cleanupMultipleModals(openModals) {
        if (openModals.length === 0) {
            this.multipleModals = [];
            this.multipleModalsCurrent = null;
            return;
        }
    }
    sortMultipleModals() {
        if (this.multipleModals === null) {
            return;
        }
        this.multipleModals.sort((a, b) => getPriority(a) - getPriority(b));
    }
    showModal() {
        this.status = ModalStatusEnum.OPENING;
        this.transitionTimeout = setTimeout(() => {
            this.status = ModalStatusEnum.OPENED;
            this.bodyScrollLock(true);
        }, 100);
    }
    /** Listen for escape key  */
    handleKeyDown(event) {
        if (this.closeOnEscKey && event.key === "Escape") {
            this.triggerClose();
        }
    }
    triggerElementClickHandler = (e) => {
        const targetElement = e.target.closest("[data-trigger-modal]");
        if (targetElement === null) {
            return;
        }
        const triggers = (targetElement.getAttribute("data-trigger-modal") || "")
            .split(";")
            .map((string) => string.split(","));
        triggers.forEach((trigger) => {
            if (trigger.length > 1) {
                switch (trigger[0].valueOf()) {
                    case "open":
                        if (trigger[1] === this.name) {
                            this.triggerOpen();
                        }
                        break;
                    case "close":
                        if (trigger[1] === undefined || trigger[1] === this.name) {
                            this.triggerClose();
                        }
                        break;
                    default:
                        break;
                }
            }
        });
    };
    componentWillLoad() {
        this.setModalStatus();
        this.initMultipleModals();
        this.onOtherClosedModal.bind(this);
        this.onOtherOpenedModal.bind(this);
    }
    componentDidLoad() {
        document.addEventListener("click", this.triggerElementClickHandler);
    }
    disconnectedCallback() {
        document.removeEventListener("click", this.triggerElementClickHandler);
    }
    render() {
        const handleClickClose = () => {
            this.triggerClose();
        };
        // @ts-expect-error Check for typing
        const currentMultiModal = this.multipleModals.indexOf(this.name) + 1;
        return (h(Host, { key: '670da38ca1c1f52aade27d184ed866f7647a4693', class: {
                ["ux-modal"]: true,
                [`ux-modal--${this.status}`]: true,
                [`ux-modal--sticky-${this.stickyPosition}`]: true,
                [`ux-modal--no-gutter-top`]: this.noGutterTop
            } }, h("div", { key: '624f10175501d49e07e02b78ac4c8057e97faf0d', class: "ux-modal__backdrop", onClick: this.closeOnBackdropClick ? handleClickClose : null }), h("div", { key: '6bfaa237dc813d1040268d6f6fca1adb54fd316f', class: "ux-modal__outer", role: "dialog", "aria-modal": true }, h("div", { key: 'fc46b26481b82ae04b45067e5112ebc705bb457a', class: "ux-modal__inner" }, h(ModalMultiIndicator, { key: '9231a50fe8ca93461102aaea60be47310d4493f3', current: currentMultiModal, total: this.multipleModals.length }), h("div", { key: '40230b6725f14ab80b9038cd9c3670b05cf871cd', class: "ux-modal__head" }, !this.noCloseButton && (h("button", { key: '5cfc3b70e67f522edce03f3eb43133dc82b7d0a5', type: "button", class: "ux-modal__close", "aria-label": this.closeButtonText, title: this.closeButtonText, onClick: handleClickClose }, h("ux-icon", { key: '0cd00efd5c6c3c221ba2dd26d43af650817fb054', name: "cross", weight: "normal" })))), h("div", { key: 'e55e0ca9cef1a3f24e87d65d0d02bd57fe20493d', class: "ux-modal__slot" }, h("slot", { key: '8c0aafacfd84fab68f094d9042dd4459cf023213' }))))));
    }
    static get is() { return "ux-modal"; }
    static get originalStyleUrls() {
        return {
            "$": ["modal.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["modal.css"]
        };
    }
    static get properties() {
        return {
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set the name of the modal"
                },
                "attribute": "name",
                "reflect": true,
                "defaultValue": "\"\""
            },
            "priority": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set the priority of the modal as integer between 1 and 10 - lower numbers have a higher importance"
                },
                "attribute": "priority",
                "reflect": false,
                "defaultValue": "5"
            },
            "closeButtonText": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The label of the close button"
                },
                "attribute": "close-button-text",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "noCloseButton": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Disables the close button in the top corner"
                },
                "attribute": "no-close-button",
                "reflect": false,
                "defaultValue": "false"
            },
            "closeOnEscKey": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If present, uxModalClose event is emitted when escape key is pressed *"
                },
                "attribute": "close-on-esc-key",
                "reflect": false,
                "defaultValue": "false"
            },
            "closeOnBackdropClick": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If present, uxModalClose event is emitted when the backdrop is clicked *"
                },
                "attribute": "close-on-backdrop-click",
                "reflect": false,
                "defaultValue": "false"
            },
            "reloadOnClose": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "reloads the page when the modal is closed"
                },
                "attribute": "reload-on-close",
                "reflect": false,
                "defaultValue": "false"
            },
            "stickyPosition": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"center\" | \"bottom\" | \"top\"",
                    "resolved": "\"bottom\" | \"center\" | \"top\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "At which vertical position should the maodal be docked *"
                },
                "attribute": "sticky-position",
                "reflect": false,
                "defaultValue": "\"center\""
            },
            "opened": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Boolean to indicate if or not the modal is currently opened"
                },
                "attribute": "opened",
                "reflect": true,
                "defaultValue": "false"
            },
            "noGutterTop": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "if set, it will eliminate the top gutter in the modal"
                },
                "attribute": "no-gutter-top",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "status": {},
            "multipleModals": {},
            "multipleModalsCurrent": {}
        };
    }
    static get events() {
        return [{
                "method": "modalClosed",
                "name": "uxModalClose",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the modal is closed"
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }, {
                "method": "modalOpened",
                "name": "uxModalOpen",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the modal is opened"
                },
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "triggerClose": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "Triggers modal closing",
                    "tags": []
                }
            },
            "triggerOpen": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "Triggers modal opening",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "domNode"; }
    static get watchers() {
        return [{
                "propName": "opened",
                "methodName": "setModalStatus"
            }];
    }
    static get listeners() {
        return [{
                "name": "uxModalClose",
                "method": "onOtherClosedModal",
                "target": "window",
                "capture": false,
                "passive": false
            }, {
                "name": "uxModalOpen",
                "method": "onOtherOpenedModal",
                "target": "window",
                "capture": false,
                "passive": false
            }, {
                "name": "keydown",
                "method": "handleKeyDown",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=modal.js.map
